'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _colors = require('@material-ui/core/colors');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** this generates a predictible array of colors
 * to display when showing bar charts on polls but could be 
 * easily used in any other component scenario that has a list 
 * that in need of visuals e.g. list of questions submissions.
 */

var SmartColor = function () {
  function SmartColor() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SmartColor);

    this.colors = config.colors || [_colors.red['500'], _colors.pink['500'], _colors.purple['500'], _colors.deepPurple['500'], _colors.indigo['500'], _colors.blue['500'], _colors.lightBlue['500'], _colors.cyan['500'], _colors.teal['500'], _colors.green['500'], _colors.lightGreen['500'], _colors.lime['500'], _colors.amber['500'], _colors.orange['500'], _colors.brown['500'], _colors.blueGrey['500']];
  }

  _createClass(SmartColor, [{
    key: 'getSmartColor',
    value: function getSmartColor(i) {
      return this.colors[i % this.colors.length];
    }
  }]);

  return SmartColor;
}();

exports.default = SmartColor;